<div class="d-flex justify-content-between">
  <div class="placeholder-glow col-8 col-sm-3">
    <span class="placeholder px-3 w-100 text_2 overflow-hidden">Loading</span>
  </div>

  <div class="placeholder-glow col-3 d-none d-lg-block">
    <span class="placeholder py-sm-2 rounded-2 w-100 text_2 overflow-hidden">Loading</span>
  </div>
</div>
